import { render, staticRenderFns } from "./ProducerSearch.vue?vue&type=template&id=8e012156&"
import script from "./ProducerSearch.vue?vue&type=script&lang=js&"
export * from "./ProducerSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProducerSearch.vue?vue&type=style&index=0&id=8e012156&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports